import { useEffect, useState } from "react";
import { ISearchResults } from "./models";
import Moment from "react-moment";

export const Results = (props: ISearchResults) => {
  const [postHovered, setPostHovered] = useState<string>();

  useEffect(() => {
    if (props.pinSelected) {
      scrollToDiv(props.pinSelected);
    }
    if (props.setPostSelected != null && props.pinSelected)
      props.setPostSelected("");
  }, [props.pinSelected, props.postSelected]);

  const scrollToDiv = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const getClassName = (id: string) => {
    if (props.pinSelected === id || props.postSelected === id) {
      return "bg-blue-100";
    }
  };

  const setSelected = (id: string | undefined) => {
    props.setPostSelected(id);
    if (props.setPinSelected != null) props.setPinSelected("");
    props.setPostSelected(id);
  };

  return props.posts?.length ? (
    <div className="flex flex-col gap-y-4">
      {props.posts?.map((post) => (
        <div
          onClick={() => setSelected(post.id)}
          onMouseEnter={() => setPostHovered(post.id)}
          onMouseLeave={() => setPostHovered("")}
          id={post.id}
          key={post.id}
          className={`flex flex-row gap-x-4 cursor-pointer hover:bg-gray-100 ${getClassName(
            post.id
          )}`}
        >
          <img src={post.thumbURL} className="rounded w-2/5" />
          <div className="flex flex-col gap-y-1 font-sans w-3/5">
            <h3 className="font-bold">{post.userName}</h3>
            <time
              dateTime={(post.updated ?? post.created).toString()}
              className="text-gray-400 text-sm mb-0"
            >
              <Moment
                date={post.updated ?? post.created}
                format="D MMMM YYYY"
              />
            </time>
            <p className="mb-0 flex-grow">
              {post.body.slice(0, 100)}
              {post.body.length > 100 ? "..." : null}
            </p>
            {postHovered == post.id && (
              <button
                className="bg-text-link text-white px-4 mr-10 py-2 rounded ml-auto mb-2"
                onClick={(e) => {
                  e.preventDefault();
                  props.showPost(post.id);
                }}
              >
                View post
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  ) : (
    <p>No Results.</p>
  );
};
